<div style="height: 100vh; display: flex; align-items: center; justify-content: center; flex-direction: column">
  @if (isUnknownUser) {
  <h2>{{ 'auth.error.unknownUser' | translate }}</h2>
  <p>{{ 'auth.error.unknownUserDetail' | translate }}</p>
  } @else {
  <h2>{{ 'auth.error.title' | translate }}</h2>
  @if (errorCode) {
  <p>{{ 'auth.error.code' | translate }} {{ errorCode }}</p>
  } }
</div>
